import { MutableRefObject, useEffect, useState, useCallback } from "react";

function useWindowSize(ref?: MutableRefObject<HTMLDivElement | null>) {
    const [windowSize, setWindowSize] = useState<{ width: number; height: number }>({
        width: typeof window !== "undefined" ? window.innerWidth : 0,
        height: typeof window !== "undefined" ? window.innerHeight : 0,
    });

    const handleResize = useCallback(() => {
        if (ref?.current) {
            setWindowSize({
                width: ref.current.offsetWidth,
                height: ref.current.offsetHeight,
            });
        } else {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        }
    }, []);

    useEffect(() => {
        window.addEventListener("resize", handleResize);
        handleResize(); // İlk değeri ayarla
        return () => window.removeEventListener("resize", handleResize);
    }, [handleResize]);

    return windowSize;
}

export default useWindowSize;
